import { Moment } from 'moment';

export const enum ActionName {
  REGISTER = 'REGISTER',
  LOGIN = 'LOGIN',
  CHNAGE_PASSWORD = 'CHNAGE_PASSWORD',
  LOCAL_FT = 'LOCAL_FT',
  IBFT = 'IBFT'
}

export interface IOtpSms {
  id?: number;
  customerId?: string;
  action?: ActionName;
  code?: number;
  used?: boolean;
  dateCreated?: Moment;
  dateExpiry?: Moment;
}

export const defaultValue: Readonly<IOtpSms> = {
  used: false
};
